export const wakeUpImage = {
  src: 'https://cdn.magicpatterns.com/uploads/5JYAG3pqfsryLjXL1BVz31/Screenshot_20260923_131415_Drive.webp',
  alt: 'The 8-Step Wake-Up Routine visual chart',
};

export const cardCategories = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/oHn34hGXEGX6EWMWwS9Q9G/Screenshot_20260923_131627_Drive.webp',
    alt: 'Category 3: Bathroom & Hygiene visual cards',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/iC1ijr6XMH1ieTjktMfPgM/Screenshot_20260923_131647_Drive.webp',
    alt: 'Category 4: Getting Ready for School visual cards',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/6uxvU4AHnD47bbpYzp5wgk/Screenshot_20260923_131706_Drive.webp',
    alt: 'Category 7: Chores & Responsibilities visual cards',
  },
];

export const executiveFunctionTools = [
  { title: 'Eliminate Choice Paralysis', desc: 'One clear icon = one clear action.' },
  { title: 'Anchor the Routine', desc: 'Predictable sequences that lower anxiety.' },
  { title: 'Build Habit Stacking', desc: 'Each card leads naturally to the next.' },
];

export const sleepAnchorImage = {
  src: 'https://cdn.magicpatterns.com/uploads/axhmTqzrXBqvpwyWJaEX2u/Screenshot_20260923_131958_Drive.webp',
  alt: 'Sleep Anchor #3: Consistent Sequence — same steps, same order, every night',
};

export const toolkitGallery = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/vtDeANVHwZomxWoWAkrcFL/Screenshot_20260923_131930_Drive.webp',
    alt: 'Transition Mini-Cards — Set 8',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/tBeVHwWN64TWydxrVTT6iz/Screenshot_20260923_131448_Drive.webp',
    alt: 'The Daily Responsibility Chart',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/c2LdLN3b5gWebSrQMxgxHy/Screenshot_20260923_131513_Drive.webp',
    alt: 'The 8-Step Bedtime Routine',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/oXkniAf18JP67anbMboNxU/Screenshot_20260923_132015_Drive.webp',
    alt: 'Visual Bedtime Schedule',
  },
];
